import React from 'react';
import {ActivityIndicator, TouchableOpacityProps} from 'react-native';
import {useTheme} from 'styled-components/native';

import {BUTTON_VARIANTS, ButtonSize, ButtonVariant, Container, Title} from './styles';

interface IButton extends TouchableOpacityProps {
  title: string;
  variant?: ButtonVariant;
  size?: ButtonSize;
  color?: string;
  onPress: () => void;
  enabled?: boolean;
  loading?: boolean;
  visualDisabled?: boolean;
  shadow?: boolean;
  mt?: number;
  mb?: number;
}

export function Button({
  title,
  variant = 'primary',
  size = 'normal',
  color,
  shadow,
  onPress,
  enabled = true,
  loading = false,
  visualDisabled = false,
  mt,
  mb,
  ...rest
}: IButton) {
  const theme = useTheme();
  const isDimmed = !enabled || loading || visualDisabled;
  const indicatorColor = shadow
    ? theme.colors.shape
    : BUTTON_VARIANTS[variant].indicatorColor(theme.colors);

  return (
    <Container
      {...rest}
      variant={variant}
      size={size}
      customColor={color}
      onPress={onPress}
      disabled={!enabled}
      activeOpacity={1}
      style={{
        opacity: isDimmed ? 0.5 : 1,
        marginTop: mt,
        marginBottom: mb,
        ...(shadow && {
          shadowColor: theme.colors.black,
          shadowOffset: {width: 0, height: 7},
          shadowOpacity: 0.2,
          shadowRadius: 6,
          elevation: 8,
        }),
      }}>
      {loading ? (
        <ActivityIndicator color={indicatorColor} />
      ) : (
        <Title variant={variant}  size={size} customColor={color}>
          {title}
        </Title>
      )}
    </Container>
  );
}
